!(function () {
  "use strict";
  var e = (e, t) => {
    let s = [];
    for (let c = 0; c < e.length; c++) s.push(t(e[c], c));
    return s;
  };
  const t = document.querySelectorAll(".faq-category-sidebar-title"),
    s = document.querySelectorAll(".faq-question"),
    c = document.querySelector("select");
  c &&
    c.addEventListener("change", () => {
      let e = c.options[c.selectedIndex],
        t =
          document.querySelector(`#${e.dataset.id}`).getBoundingClientRect()
            .top +
          window.scrollY -
          80;
      window.scroll({ top: t, behavior: "smooth" });
    });
  let i = null;
  e(s, (t) => {
    t.addEventListener("click", () => {
      (i = t.id),
        e(s, (e) => {
          let t = e.id,
            s = e.querySelector(".faq-answer");
          i === t
            ? (e.classList.toggle("active"), s.classList.toggle("active"))
            : (s.classList.remove("active"), e.classList.remove("active"));
        });
    });
  }),
    e(t, (s) => {
      s.addEventListener("click", () => {
        let c = s.dataset.index;
        e(t, (e) => {
          e.dataset.index === c
            ? e.classList.contains("active") || e.classList.add("active")
            : e.classList.contains("active") && e.classList.remove("active");
        });
      });
    });
})();
